import React from "react";
import { Button } from "../../button";
import "./sidebar-options-list.css";

const SidebarOptionsList = ({
	type,
	children,
}: {
	type: "list" | "grid";
	children: React.ReactNode;
}) => {
	return (
		<div
			className={"sidebar-options-list"}
			data-type={type}
			role={type === "list" ? "radiogroup" : undefined}
		>
			{children}
		</div>
	);
};

const SidebarOptionsItem = ({
	type,
	children,
	title,
	icon,
	subTitle,
	isActive,
	onClick,
	className,
	style,
}: {
	type?: "list" | "grid";
	children?: React.ReactNode;
	title?: React.ReactNode;
	icon?: React.ReactNode;
	subTitle?: React.ReactNode;
	isActive?: boolean;
	onClick?: () => void;
	className?: string;
	style?: React.CSSProperties;
}) => {
	if (type === "grid") {
		return (
			<Button
				className={`sidebar-options-list__item ${className || ""}`}
				style={style}
				onClick={onClick}
				checked={isActive}
				disabled={!onClick}
			>
				{children ?? (
					<div className={`sidebar-options-list__content`}>
						{icon && <div className="sidebar-options-list__icon">{icon}</div>}
						{title && <div className="sidebar-options-list__title">{title}</div>}
						{subTitle && (
							<div className="sidebar-options-list__subtitle">{subTitle}</div>
						)}
					</div>
				)}
			</Button>
		);
	}

	return (
		<button
			className={`sidebar-options-list__item ${className || ""}`}
			style={style}
			onClick={onClick}
			role="radio"
			aria-label={typeof title === "string" ? title : undefined}
			aria-checked={isActive}
			data-checked={isActive ? "" : undefined}
			disabled={!onClick}
		>
			{children ?? (
				<div className={`sidebar-options-list__content`}>
					{icon && <div className="sidebar-options-list__icon">{icon}</div>}
					{title && <div className="sidebar-options-list__title">{title}</div>}
					{subTitle && <div className="sidebar-options-list__subtitle">{subTitle}</div>}
				</div>
			)}
			<div className="sidebar-options-list__item-checkmark" aria-hidden="true">
				&#xe98d;
			</div>
		</button>
	);
};

export const SidebarOptions = {
	List: SidebarOptionsList,
	Item: SidebarOptionsItem,
};
